import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable no-undefined */
import React from "react";
//Limitless imports
import { useCustomerMessageContext } from "../../../hooks";
import { useTranslation } from "../../../../common/hooks/translation/TranslationContext";
import ActionControlsFooter from "../action-controls-footer/ActionControlsFooter";
import TimeSinceFooter from "../time-since-footer/TimeSinceFooter";
import ResponseBox from "../../response-box/ResponseBox";
import FooterTitle from "../footer-title/FooterTitle";
import CSATFooter from "../csat-footer/CSATFooter";
import ClosedMessageFooter from "../closed-message-footer/ClosedMessageFooter";
import { withi18n } from "../../hocs/i18n";
import LoadingFooter from "../loading-footer/LoadingFooter";
import RateFinishMessageOverlay from "../rate-finish-message-overlay/RateFinishMessageOverlay";
import ButtonFooter from "../button-footer/ButtonFooter";
import { MESSAGE_STATE_NEW, MESSAGE_STATE_ACCEPT_ANSWER_PROMPT, MESSAGE_STATE_RATE_AMBASSADOR, MESSAGE_STATE_CLOSED, MESSAGE_STATE_SUGGESTED_ANSWER, MESSAGE_STATE_TIMEDOUT, MESSAGE_STATE_REPORTED, MESSAGE_STATE_FORWARDED, MESSAGE_STATE_RERATE_YOUR_EXPERIENCE, MESSAGE_STATE_PENDING_CLOSURE, MESSAGE_CUSTOMER_OPINION_ACCEPT, MESSAGE_CUSTOMER_OPINION_SCORE, MESSAGE_STATE_LOADING } from "../../../utils";

var ConversationFooter = function ConversationFooter(_ref) {
  var _TITLES, _FOOTER_MAP;

  var scrollConversationCallback = _ref.scrollConversationCallback,
      suggestedAnswerHandle = _ref.suggestedAnswerHandle,
      rejectSuggestedAnswerHandle = _ref.rejectSuggestedAnswerHandle,
      newMessageHandle = _ref.newMessageHandle,
      testimonialFullScreen = _ref.testimonialFullScreen,
      mockFooter = _ref.mockFooter,
      toggleInputFocus = _ref.toggleInputFocus;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isTyping = _React$useState2[0],
      setTyping = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dialogVisibility = _React$useState4[0],
      setDialogVisibility = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      hasCustomerClosed = _React$useState6[0],
      setHasCustomerClosed = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      hasClickedCustomerAccept = _React$useState8[0],
      setHasClickedCustomerAccept = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      hasClickedRateExperience = _React$useState10[0],
      setHasClickedRateExperience = _React$useState10[1];

  var _useCustomerMessageCo = useCustomerMessageContext(),
      message = _useCustomerMessageCo.message,
      acceptAnswer = _useCustomerMessageCo.acceptAnswer,
      submitScore = _useCustomerMessageCo.submitScore,
      addDialogue = _useCustomerMessageCo.addDialogue,
      submitTestimonial = _useCustomerMessageCo.submitTestimonial;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  React.useEffect(function () {
    var messageId = message.messageId,
        accepted = message.accepted,
        customerScore = message.customerScore,
        custTestimonial = message.custTestimonial,
        lastExpertDialogueDate = message.lastExpertDialogueDate,
        acceptedDate = message.acceptedDate,
        footerState = message.footerState;

    if (messageId && accepted && (!customerScore || !custTestimonial)) {
      if (lastExpertDialogueDate < acceptedDate && !hasCustomerClosed) {
        setDialogVisibility(true);
      }
    }

    if (message.custTestimonial && footerState === MESSAGE_STATE_CLOSED) {
      setDialogVisibility(false);
    }
  }, [message.accepted, message.customerScore, message.custResolved, message.custTestimonial]);
  /* to handle the scenario where a customer is viewing a message that has it's lifecycle restarted */

  React.useEffect(function () {
    if (message.accepted === undefined && hasClickedCustomerAccept) {
      setHasClickedCustomerAccept(false);
    }
  }, [message.accepted]);

  var responseBoxSubmitHandle = function responseBoxSubmitHandle(response, callback) {
    if (!mockFooter) {
      addDialogue(response, callback);
    }
  };

  var acceptAnswerHandle = function acceptAnswerHandle() {
    if (!mockFooter) {
      acceptAnswer(true, function () {
        //wait for callback before
        setDialogVisibility(true);
      });
    } else {
      setHasClickedCustomerAccept(false);
    }
  };

  var rejectAnswerHandle = function rejectAnswerHandle() {
    if (!mockFooter) {
      acceptAnswer(false);
      setHasClickedCustomerAccept(false);
    } else {
      setHasClickedCustomerAccept(false);
    }
  };

  var submitCSATHandle = function submitCSATHandle(score, callback) {
    if (!mockFooter) {
      submitScore(score, callback);
    }
  };

  var handleCustomerAccept = function handleCustomerAccept() {
    setHasClickedCustomerAccept(true);
  };

  var renderResponseBox = function renderResponseBox() {
    return /*#__PURE__*/React.createElement(ResponseBox, {
      onClickHandle: responseBoxSubmitHandle,
      scrollConversationCallback: scrollConversationCallback,
      toggleInputFocus: toggleInputFocus
    });
  };

  var renderCustomerOpinionAccept = function renderCustomerOpinionAccept() {
    if (hasClickedCustomerAccept) {
      return renderAmbassadorResponseFooter();
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: handleCustomerAccept,
      title: "Does this answer your question?",
      id: "customerAcceptButton"
    }));
  };

  var renderNewConversationFooter = function renderNewConversationFooter() {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), /*#__PURE__*/React.createElement(TimeSinceFooter, null));
  };

  var renderRateFinishFooter = function renderRateFinishFooter() {
    return /*#__PURE__*/React.createElement(RateFinishMessageOverlay, {
      open: dialogVisibility,
      message: message,
      onSubmitCSATScore: submitCSATHandle,
      onSubmitTestimonialHandle: function onSubmitTestimonialHandle(testimonial) {
        submitTestimonial(testimonial);
        setHasCustomerClosed(true);
        setDialogVisibility(false);
      },
      fullScreen: testimonialFullScreen,
      onCancelDialog: function onCancelDialog() {
        setHasCustomerClosed(true);
        setDialogVisibility(false);
      }
    });
  };

  var renderSuggestedAnswerFooter = function renderSuggestedAnswerFooter() {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: "Are you happy with the suggested answer?"
    }), /*#__PURE__*/React.createElement(ActionControlsFooter, {
      leftButtonTitle: "Yes",
      leftButtonHandle: function leftButtonHandle() {
        return suggestedAnswerHandle(function () {
          setDialogVisibility(true);
        });
      },
      rightButtonTitle: "Continue",
      rightButtonHandle: rejectSuggestedAnswerHandle
    }));
  };

  var renderAmbassadorResponseFooter = function renderAmbassadorResponseFooter() {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: "Does this answer your question?"
    }), /*#__PURE__*/React.createElement(ActionControlsFooter, {
      leftButtonTitle: "Yes",
      leftButtonHandle: acceptAnswerHandle,
      rightButtonTitle: "Continue",
      rightButtonHandle: rejectAnswerHandle
    }));
  };

  var renderRateAmbassadorFooter = function renderRateAmbassadorFooter() {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(ResponseBox, {
      onClickHandle: responseBoxSubmitHandle,
      scrollConversationCallback: scrollConversationCallback,
      onTypingHandler: function onTypingHandler(flag) {
        return setTyping(flag);
      },
      toggleInputFocus: toggleInputFocus
    }), /*#__PURE__*/React.createElement(CSATFooter, {
      onClickHandle: submitCSATHandle,
      message: message,
      isTyping: isTyping
    }));
  };

  var renderCustomerRateExperience = function renderCustomerRateExperience() {
    if (hasClickedRateExperience) {
      return renderRateAmbassadorFooter();
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: function onClick() {
        return setHasClickedRateExperience(true);
      },
      title: "Rate your experience",
      id: "rateYourExperienceButton"
    }));
  };

  var renderRerateExperience = function renderRerateExperience() {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: function onClick() {
        return setDialogVisibility(true);
      },
      title: "Rate your experience",
      id: "rateYourExperienceButton"
    }));
  };

  var renderTitleFooter = function renderTitleFooter(title) {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: t(title)
    }), /*#__PURE__*/React.createElement(ClosedMessageFooter, {
      message: message,
      onButtonClick: newMessageHandle
    }));
  };

  var renderLoading = function renderLoading() {
    return /*#__PURE__*/React.createElement(LoadingFooter, null);
  };

  var footerState = message.footerState;
  var TITLES = (_TITLES = {}, _defineProperty(_TITLES, MESSAGE_STATE_TIMEDOUT, "Your question has timed out and been forwarded"), _defineProperty(_TITLES, MESSAGE_STATE_REPORTED, "This question has been reported and is being reviewed"), _defineProperty(_TITLES, MESSAGE_STATE_FORWARDED, "Your Question has been forwarded"), _defineProperty(_TITLES, MESSAGE_STATE_CLOSED, "Your question has been successfully answered"), _defineProperty(_TITLES, MESSAGE_STATE_PENDING_CLOSURE, "Thank you for your feedback"), _TITLES);
  var FOOTER_MAP = (_FOOTER_MAP = {}, _defineProperty(_FOOTER_MAP, MESSAGE_STATE_SUGGESTED_ANSWER, {
    renderMethod: renderSuggestedAnswerFooter
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_ACCEPT_ANSWER_PROMPT, {
    renderMethod: renderAmbassadorResponseFooter
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_RATE_AMBASSADOR, {
    renderMethod: renderRateAmbassadorFooter
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_TIMEDOUT, {
    renderMethod: renderTitleFooter,
    renderParam: TITLES[footerState]
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_REPORTED, {
    renderMethod: renderTitleFooter,
    renderParam: TITLES[footerState]
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_FORWARDED, {
    renderMethod: renderTitleFooter,
    renderParam: TITLES[footerState]
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_CLOSED, {
    renderMethod: renderTitleFooter,
    renderParam: TITLES[footerState]
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_LOADING, {
    renderMethod: renderLoading
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_NEW, {
    renderMethod: renderNewConversationFooter
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_RERATE_YOUR_EXPERIENCE, {
    renderMethod: renderRerateExperience
  }), _defineProperty(_FOOTER_MAP, MESSAGE_STATE_PENDING_CLOSURE, {
    renderMethod: renderTitleFooter,
    renderParam: TITLES[footerState]
  }), _defineProperty(_FOOTER_MAP, MESSAGE_CUSTOMER_OPINION_ACCEPT, {
    renderMethod: renderCustomerOpinionAccept
  }), _defineProperty(_FOOTER_MAP, MESSAGE_CUSTOMER_OPINION_SCORE, {
    renderMethod: renderCustomerRateExperience
  }), _FOOTER_MAP);
  var _FOOTER_MAP$footerSta = FOOTER_MAP[footerState],
      renderMethod = _FOOTER_MAP$footerSta.renderMethod,
      renderParam = _FOOTER_MAP$footerSta.renderParam;
  return /*#__PURE__*/React.createElement("div", null, renderParam ? renderMethod(renderParam) : renderMethod(), renderRateFinishFooter());
};

export default withi18n(ConversationFooter);
ConversationFooter.defaultProps = {
  mockFooter: false,
  toggleInputFocus: function toggleInputFocus() {
    return null;
  }
};